// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, createOrUpdate, get } from "./operations.js";
export type {
  ObjectReplicationPoliciesListOptionalParams,
  ObjectReplicationPoliciesDeleteOptionalParams,
  ObjectReplicationPoliciesCreateOrUpdateOptionalParams,
  ObjectReplicationPoliciesGetOptionalParams,
} from "./options.js";
